import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class LoadService {
	private _currentRequestCalls: number = 0;
	private _requestCallsSubject$ = new BehaviorSubject(0);

	public isLoading(): Observable<boolean> {
		return this._requestCallsSubject$.pipe(map((requestCount) => requestCount > 0));
	}

	public startRequest(): void {
		this._currentRequestCalls++;
		this._requestCallsSubject$.next(this._currentRequestCalls);
	}

	public stopRequest(): void {
		this._currentRequestCalls--;
		this._requestCallsSubject$.next(this._currentRequestCalls);
	}
}
